import WorkWeekOptionState from '../data/store/schema/WorkWeekOptionState';

/**
 * Calculates the updated workDays value.
 * @checked: true/false state of the checkbox
 * @workDays: current work days value
 * @weekDay: option state obj corresponding to the clicked checkbox item
 */
const calculateUpdatedWorkDays = (
    checked: boolean,
    workDays: number,
    weekDay: WorkWeekOptionState
): number => (checked ? workDays + weekDay.key : workDays - weekDay.key);

export default calculateUpdatedWorkDays;
